<template>
  <v-container>
    <v-layout align-center>
      <v-flex>
        <div class="title">Gallery</div>
      </v-flex>
      <v-flex text-right>
        <v-btn
          color="primary"
          class="text-none subtitle-2 my-4"
          @click="openImageUploadDialog"
        >
          <v-icon small class="mr-2"> mdi-image-multiple </v-icon>
          <div>Upload Images</div>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs4>
        <div class="subtitle-2 mb-1">Select Entity</div>
        <v-autocomplete
          :loading="loading"
          v-model="entity"
          :items="reviewedEntities"
          cache-items
          :search-input.sync="searchTerm"
          hide-details
          return-object
          item-text="title"
          item-value="title"
          placeholder="Select Entity"
          no-data-text="Type a name of an entity to search"
          outlined
          chips
          dense
          @change="getAssetsByEntity"
        ></v-autocomplete>
      </v-flex>
      <v-flex text-right>
        <!-- <v-layout> -->
        <v-btn-toggle v-model="toggle_exclusive" mandatory>
          <v-btn icon>
            <v-icon> mdi-dots-grid </v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon> mdi-format-list-text </v-icon>
          </v-btn>
        </v-btn-toggle>
        <!-- </v-layout> -->
      </v-flex>
    </v-layout>

    <v-layout class="mt-3">
      <v-flex xs6>
        <v-text-field v-model="imageSearchTerm" label="Search" />
      </v-flex>
    </v-layout>

    <v-card outlined class="mt-3">
      <v-container grid-list v-if="toggle_exclusive === 0">
        <v-row>
          <v-col
            cols="3"
            class="d-flex child-flex"
            v-for="(item, i) in assets"
            :key="i"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-card v-bind="attrs" v-on="on">
                  <v-img
                    aspect-ratio="1"
                    :lazy-src="item.image.url"
                    :src="item.image.url"
                  >
                    <v-layout>
                      <v-flex text-right class="mr-2">
                        <div class="mt-2">
                          <v-btn @click="editItem(item)" fab x-small>
                            <v-icon> mdi-pencil </v-icon>
                          </v-btn>
                        </div>
                        <div class="mt-2">
                          <v-btn @click="deleteItem(item)" fab x-small>
                            <v-icon> mdi-delete </v-icon>
                          </v-btn>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-img>
                </v-card>
              </template>
              <span>{{ item.entity.title }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
      <v-simple-table v-else>
        <template v-slot:default>
          <thead>
            <tr>
              <th>Image</th>

              <th class="text-left">Entity Name</th>
              <th class="text-left">Created At</th>
              <th class="text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in assets" :key="`list-${i}`">
              <td class="py-4">
                <v-card width="50">
                  <v-img aspect-ratio="1" :src="item.image.url" />
                </v-card>
              </td>

              <td>
                {{ item.entity.title }}
              </td>
              <td>{{ iMoment(item.createdAt) }}</td>
              <td>
                <v-icon @click="editItem(item)" small class="mr-2">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-layout class="py-10" v-if="assets.length === 0">
        <v-flex text-center class="mx-10 grey--text text--darken-2 body-2">
          Looks like there are no Images for that Entity. Try another entity or
          upload images from the gallery.
        </v-flex>
      </v-layout>
      <v-layout
        justify-center
        v-if="assets.length > 0 && entity === '' && imageSearchTerm != ''"
      >
        <v-btn
          color="primary"
          class="text-none subtitle-2 my-4"
          @click="getMoreSearchAssets({ searchTerm: imageSearchTerm })"
        >
          Load more
        </v-btn>
      </v-layout>
      <v-layout justify-center v-else-if="assets.length > 0 && entity === ''">
        <v-btn
          color="primary"
          class="text-none subtitle-2 my-4"
          @click="getMoreAssets()"
        >
          Load more
        </v-btn>
      </v-layout>
      <v-layout justify-center v-if="assets.length > 0 && entity">
        <v-btn
          color="primary"
          class="text-none subtitle-2 my-4"
          @click="getMoreAssetsByEntityId(entity.id)"
        >
          Load more
        </v-btn>
      </v-layout>
      <v-layout justify-center class="pb-6" v-if="assets.length === 0">
        <div class="grey--text text--darken-2">
          Select an Entity to view the images for the entity.
        </div>
      </v-layout>
    </v-card>
    <upload-image-dialog ref="uploadImageDialogRef" />
    <edit-image-dialog ref="editImageDialogRef" />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import UploadImageDialog from '../components/UploadImageDialog.vue';
import EditImageDialog from '../components/EditImageDialog';
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
export default {
  components: { UploadImageDialog, EditImageDialog },
  data() {
    return {
      searchTerm: '',
      imageSearchTerm: '',
      entity: '',
      loading: false,
      dialogDelete: false,
      toggle_exclusive: 0,
      itemToDelete: {},
    };
  },
  computed: {
    ...mapState('$_assets', ['assets']),
    ...mapState('$_entity', ['reviewedEntities']),
  },
  created() {
    this.getAssets();
  },
  watch: {
    searchTerm: _.debounce(function(e) {
      e && this.searchEntities(e);
    }, 300),
    imageSearchTerm: _.debounce(function(e) {
      if (e === '') {
        this.getAssets();
      }
      e && this.searchImages(e);
    }, 300),
  },

  methods: {
    ...mapActions({
      getAssets: '$_assets/getAssets',
      getMoreAssets: '$_assets/getMoreAssets',
      getMoreSearchAssets: '$_assets/searchMoreAssets',
      searchAssets: '$_assets/searchAssets',
      deleteAsset: '$_assets/deleteAsset',
      searchEntitiesAction: '$_entity/searchContent',
      getAssetsByEntityId: '$_assets/getAssetsByEntityId',
      getMoreAssetsByEntityId: '$_assets/getMoreAssetsByEntityId',
    }),
    searchImages(imageSearchTerm) {
      this.loading = true;
      console.log('searching Tags: ', imageSearchTerm);
      if (this.entity) {
        this.searchAssets({
          searchTerm: imageSearchTerm,
          entity: this.entity,
        }).then(() => {
          this.loading = false;
        });
      } else {
        this.searchAssets({ searchTerm: imageSearchTerm }).then(() => {
          this.loading = false;
        });
      }
    },
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format('lll');
      } else {
        return 0;
      }
    },
    searchEntities(searchTerm) {
      this.loading = true;
      console.log('searching Tags: ', searchTerm);

      this.searchEntitiesAction({
        collection: 'entities',
        mutation: 'updateReviewedEntities',
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },

    getAssetsByEntity(entity) {
      if (entity) {
        this.getAssetsByEntityId(entity.id);
      }
    },
    openImageUploadDialog() {
      this.$refs.uploadImageDialogRef.toggleDialog();
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.deleteAsset({ details: this.itemToDelete }).then(() => {
        if (this.entity) {
          this.getAssetsByEntityId(this.entity.id);
          this.dialogDelete = false;
        } else {
          this.getAssets();
          this.dialogDelete = false;
        }
      });
    },

    editItem(item) {
      this.$refs.editImageDialogRef.toggleDialog(item);
      console.log('edit item: ', item);
    },
  },
};
</script>

<style></style>
